import React from 'react'
import { useDispatch } from 'react-redux';
import { getReportEmployeeShifts } from '../actions';
import EmployeeShifts from './EmployeeShifts';

const Report = ({ report }) => {
    const dispatch = useDispatch()
    return (
    <div>
        Report: <br/>
        {/* {report.employeeTipOut.length > 0 ? report.employeeTipOut.map(i => {
            <div>
                <span><label>Name: </label></span><span>{i.EmployeeName}</span><span>&nbsp;&nbsp;&nbsp;TipOut: </span><span>{i.TipOutSummary}</span>
            </div>
        }): null} */}
        <label>Total Sushi TipOut: </label>&nbsp;&nbsp;&nbsp;{report.totalSushiTipOut} <p/>
        <label>{report.employeeTipOut.employeeName}: </label>&nbsp;&nbsp;&nbsp;{report.employeeTipOut.TipOutSummary} <p/>
        <button onClick={() => {
             dispatch(getReportEmployeeShifts(report.restaurantId, report.employeeTipOut.employeeId, report.beginDate, report.endDate))
        }}>Show shifts</button>
        <EmployeeShifts employeeShifts={report.employeeShifts}/>
    </div>
)}

export default Report